import { render, staticRenderFns } from "./BlogsSection.vue?vue&type=template&id=68b3ac51&"
import script from "./BlogsSection.vue?vue&type=script&lang=js&"
export * from "./BlogsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports